// French formatting helpers (fr-FR)
const eurFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency", currency: "EUR", maximumFractionDigits: 0,
});
const eurWithCentsFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2,
});
const numFormatter = new Intl.NumberFormat("fr-FR");
const percentFormatter = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 1, maximumFractionDigits: 1,
});

export function formatEuro(value, withCents = false) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return (withCents ? eurWithCentsFormatter : eurFormatter).format(Number(value));
}

export function formatNumber(value) {
  if (value == null) return "—";
  return numFormatter.format(Number(value));
}

export function formatPercent(value) {
  if (value == null) return "—";
  return `${percentFormatter.format(Number(value))} %`;
}

export function formatDateFr(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTimeFr(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("fr-FR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris",
  });
}

export function formatSiren(v) {
  if (!v) return "—";
  const s = String(v).replace(/\s/g, "");
  return s.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
}
